<template>
  <div>
    <div class="hg-farmer" v-if="$store.state.appConfig.windowWidth >= 769">
      <div class="result-container" v-show="!$store.state.ancientProxResult.isOpenedAncientProxDetail">
        <ClosestPopulationsTopHeader />
        <ClosestPopulationView />
      </div>
      <div class="result-container" v-show="$store.state.ancientProxResult.isOpenedAncientProxDetail">
        <GeneticSimilarityProximity />
      </div>
      <div class="detail-container">
        <ClosestPopulationMap v-if="$store.state.ancientProxResult.uiResults"/>
      </div>
    </div>

    <template v-else>
      <GeneticSimilarityProximity v-show="$store.state.ancientProxResult.isOpenedAncientProxDetail"/>
      <div v-show="!$store.state.ancientProxResult.isOpenedAncientProxDetail">
        <div class="genetic-similarity-mobile">
          <ClosestPopulationMap v-if="$store.state.ancientProxResult.uiResults" class="mobile-map"/>
          <div class="mobile-container"
            :style="{ transform: 'translateY(' + contentPosition + 'px)' }">
            <div
              @touchstart="startDrag"
              @touchmove="onDrag"
              @touchend="endDrag">
              <ClosestPopulationsTopHeader :contentPosition="contentPosition" />
            </div>
            <div :class="{'scrollable-wrapper': contentPosition === 0}">
              <ClosestPopulationView />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ClosestPopulationCalculateWatcher from './services/ClosestPopulationCalculateWatcher';
import ClosestPopulationsTopHeader from './ClosestPopulationsTopHeader.vue';

import ClosestPopulationView from './pages/ClosestPopulationView.vue';
import ClosestPopulationMap from './pages/ClosestPopulationMap.vue';

import GeneticSimilarityProximity from '../genetic-similarities/proximity/GeneticSimilarityProximity.vue';

export default {
  components: {
    ClosestPopulationsTopHeader,
    ClosestPopulationView,
    ClosestPopulationMap,
    GeneticSimilarityProximity,
  },
  data() {
    return {
      startY: 0,
      contentPosition: 250,
      minPosition: 0,
      maxPosition: 250,
    };
  },
  methods: {
    startDrag(event) {
      this.startY = event.touches[0].clientY - this.contentPosition;
    },
    onDrag(event) {
      let newY = event.touches[0].clientY - this.startY;
      if (newY < this.minPosition) newY = this.minPosition;
      if (newY > this.maxPosition) newY = this.maxPosition;
      if(newY >= 0) {
        this.contentPosition = newY;
      }
    },
    endDrag() {
      if (this.contentPosition < 245) {
        this.contentPosition = 0;
      }
    },
  },
  mounted() {
    ClosestPopulationCalculateWatcher.init();
    
    if (this.$store.state.appConfig.windowWidth < 769) {
      document.body.classList.add('fixed-scroll-iframe');
    }
  },
  beforeDestroy() {
    if (this.$store.state.appConfig.windowWidth < 769) {
      document.body.classList.remove('fixed-scroll-iframe');
    }
  },
};
</script>

<style lang="scss" scoped>
.hg-farmer {
  width: 100%;
  display: flex;

  .result-container {
    z-index: 1;
    display: inline-block;
    position: relative;
    width: 40%;
    display: flex;
    flex-direction: column;
    height: 100vh; 
  }
  .detail-container {
    width: 60%;
    flex-grow: 1;
    height: auto;
    position: relative;
  }
}

.genetic-similarity-mobile {
  height: 100vh;
  .mobile-map {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .mobile-container {
    display: flex;
    flex-direction: column;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: calc(100%);
    transition: transform 0.3s ease;
    will-change: transform;
    z-index: 1001;
    background-color: var(--bg-body-color);

    .scrollable-wrapper {
      overflow-y: auto;
      background-color: var(--bg-body-color);
    }
  }
}

.genetic-similarity-mobile-other {
  height: 100vh;
  overflow-x: hidden;
  .period-header {
    padding-bottom: 42px;
    background-color: var(--white-100);
  }
}
</style>